import { render, staticRenderFns } from "./ModalGalleryAdd.vue?vue&type=template&id=60d356ae"
import script from "./ModalGalleryAdd.vue?vue&type=script&lang=js"
export * from "./ModalGalleryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports